import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Lib from '../../../commons/lib';
import AllapotLista from './AllapotLista';
import EsettipusLista from './EsettipusLista';
import ElerhetosegLista from './ElerhetosegLista';
import CustomTooltip from './../../../components/Tooltip/CustomTooltip';
import getTooltip from './../UgyfelszolgalatTooltips';

class UgyfelszolgalatTabBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1'
    };
  }

  componentDidMount() {
    this.initTab();
  }

  initTab = () => {
    let activeTab = '1';
    if (this.props.globals.hasRole(['UGYFELSZOLGALAT_ELERHETOSEG'])) activeTab = '3';
    if (this.props.globals.hasRole(['UGYFELSZOLGALAT_ESETTIPUS'])) activeTab = '2';
    if (this.props.globals.hasRole(['UGYFELSZOLGALAT_ALLAPOT'])) activeTab = '1';
    this.setState({ activeTab: activeTab });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">{"Ügyfélszolgálat törzsadatok"}</div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['UGYFELSZOLGALAT_ALLAPOT']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => {
                          this.toggle('1');
                          // if (this.child1) this.child1.updateTable();
                        }}
                      >
                        {'Állapot'}
                        <CustomTooltip text={getTooltip('allapot')} id="allapotTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['UGYFELSZOLGALAT_ESETTIPUS']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => {
                          this.toggle('2');
                          // if (this.child2) this.child2.updateTable();
                        }}
                      >
                        {'Esettípus'}
                        <CustomTooltip text={getTooltip('esettipus')} id="esettipusTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['UGYFELSZOLGALAT_ELERHETOSEG']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => {
                          this.toggle('3');
                          // if (this.child3) this.child3.updateTable();
                        }}
                      >
                        {'Elérhetőség'}
                        <CustomTooltip text={getTooltip('elerhetoseg')} id="elerhetosegTT" />
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                {(this.props.globals.hasRole(['UGYFELSZOLGALAT_ALLAPOT'])
                || this.props.globals.hasRole(['UGYFELSZOLGALAT_ESETTIPUS'])
                || this.props.globals.hasRole(['UGYFELSZOLGALAT_ELERHETOSEG'])) && (
                <TabContent activeTab={this.state.activeTab}>
                  {
                    this.props.globals.hasRole(['UGYFELSZOLGALAT_ALLAPOT']) && (
                      <TabPane tabId="1">
                        <AllapotLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child1 = instance; }}
                          active={this.state.activeTab === '1'}
                        />
                      </TabPane>
                    )}
                    {
                    this.props.globals.hasRole(['UGYFELSZOLGALAT_ESETTIPUS']) && (
                      <TabPane tabId="2">
                        <EsettipusLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child2 = instance; }}
                          active={this.state.activeTab === '2'}
                        />
                      </TabPane>
                    )}
                    {
                    this.props.globals.hasRole(['UGYFELSZOLGALAT_ELERHETOSEG']) && (
                      <TabPane tabId="3">
                        <ElerhetosegLista
                          {...this.props}
                          globals={this.props.globals}
                          ref={(instance) => { this.child3 = instance; }}
                          active={this.state.activeTab === '3'}
                        />
                      </TabPane>
                    )}
                </TabContent>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UgyfelszolgalatTabBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default UgyfelszolgalatTabBase;
